/*
 * Copyright (c) 2020. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
 */

import ServerRequest from "./server-request";
import urlJoin from "proper-url-join";

const searchPlants = async filter => {
  let request = new ServerRequest(
    urlJoin(process.env.VUE_APP_BACKEND_URL, "search/plants")
  );
  let { data } = await request.get({
    ...filter
  });
  return data;
};

const SearchService = {
  searchPlants
};

export default SearchService;
export { searchPlants };
